


// import React, { useState, useEffect } from "react";
// import { Button, Box, Typography, CircularProgress } from "@mui/material";
// import { QrReader } from "react-qr-reader";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { useDispatch, useSelector } from "react-redux";
// import { QrInOut } from "../actions/QrAction";
// import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
// import { format } from "date-fns";

// const QRScanner = () => {
//   const dispatch = useDispatch();
//   const [data, setData] = useState(""); // Stores scanned QR code result
//   const [action, setAction] = useState(""); // State for action selection
//   const [scanning, setScanning] = useState(false);
//   const [userLocation, setUserLocation] = useState(null);
//   const { loading, error, data: apiResponse } = useSelector((state) => state.qr);
//   const role = localStorage.getItem("role");

//   // Trigger post data when location is updated
//   useEffect(() => {
//     if (userLocation) sendPostData();
//   }, [userLocation]);

  

//   // Fetch user's location
//   const fetchLocation = async () => {
//     try {
//       if (!"geolocation" in navigator) {
//         throw new Error("Geolocation not supported");
//       }

//       return new Promise((resolve, reject) => {
//         navigator.geolocation.getCurrentPosition(
//           (position) => resolve(position),
//           (error) => reject(error),
//           { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
//         );
//       });
//     } catch (err) {
//       console.error("Error fetching location:", err);
//     }
//   };

//   // Handle action selection (Check In/Check Out)
//   const handleAction = (selectedAction) => {
//     setAction(selectedAction);
//     setData("");
//     setScanning(true);
//   };

//   // Reset scanning state
//   const resetScanning = () => {
//     setScanning(false);
//     setAction("");
//     setData("");
//   };

//   // Format current date and time
//   const getFormattedDate = () => format(new Date(), "yyyy-MM-dd HH:mm:ss.SSS");

//   // Post scanned data to the server
//   const sendPostData = async () => {
//     if (!data || !userLocation) return;

//     const postData = {
//       serviceNo: data,
//       InOut: action === "checkIn" ? 1 : 2,
//       dateTime: getFormattedDate(),
//       geoLocation: JSON.stringify({
//         latitude: userLocation.coords.latitude,
//         longitude: userLocation.coords.longitude,
//         accuracy: userLocation.coords.accuracy,
//         altitude: userLocation.coords.altitude,
//         heading: userLocation.coords.heading,
//         speed: userLocation.coords.speed,
//       }),
//       location: role,
//     };

//     try {
//       dispatch(QrInOut(postData));
//       console.log("Data posted successfully:", postData);
//     } catch (err) {
//       console.error("Error posting data:", err);
//     }
//   };

//   // Render action buttons (Check In/Check Out)
//   const renderActionButtons = () => (
//     <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}>
//       <Button
//         variant="contained"
//         sx={{
//           borderRadius: "20px",
//           padding: "12px 24px",
//           backgroundColor: "#142c54",
//           fontWeight: "bold",
//           "&:hover": { backgroundColor: "#1B5E20" },
//         }}
//         onClick={() => handleAction("checkIn")}
//       >
//         <FiArrowDownLeft size={20} color="#FFFFFF" /> Check In
//       </Button>
//       <Button
//         variant="contained"
//         sx={{
//           borderRadius: "20px",
//           padding: "12px 24px",
//           backgroundColor: "#B71C1C",
//           color: "#FFFFFF",
//           fontWeight: "bold",
//           "&:hover": { backgroundColor: "#B71C1C" },
//         }}
//         onClick={() => handleAction("checkOut")}
//       >
//         <FiArrowUpRight size={20} color="#FFFFFF" /> Check Out
//       </Button>
//     </Box>
//   );

//   // Render QR scanner
//   const renderScanner = () => (
//     <Box
//       sx={{
//         width: "100%",
//         maxWidth: "400px",
//         mt: 4,
//         margin: "0 auto",
//         textAlign: "center",
//         position: "relative",
//       }}
//     >
//       <Typography
//         variant="h6"
//         sx={{ fontWeight: 600, mb: 2, color: "#154C79" }}
//       >
//         {action === "checkIn" ? "Check In QR Scan Open Now" : "Check Out QR Scan Open Now"}
//       </Typography>
//       <Button
//         variant="outlined"
//         sx={{
//           margin: "0 auto",
//           mt: 5,
//           display: "block",
//           color: "#154C79",
//           borderColor: "#003366",
//           "&:hover": { borderColor: "#002244" },
//         }}
//         onClick={resetScanning}
//       >
//         Back
//       </Button>
//       <Box
//         sx={{
//           width: "100%",
//           maxWidth: "400px",
//           height: "400px",
//           borderRadius: "8px",
//           overflow: "hidden",
//           boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//           backgroundColor: "#fff",
//         }}
//       >
//         <QrReader
//           onResult={(result) => {
//             if (result) {
//               setData(result?.text);
//               setScanning(false);
//               fetchLocation().then(setUserLocation).catch(console.error);
//             }
//           }}
//           constraints={{ facingMode: "environment" }}
//         />
//       </Box>
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         height: "100vh",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <HeaderBannerPage />
//       <Box
//         sx={{
//           padding: "1px",
//           fontFamily: "Arial, sans-serif",
//           maxHeight: "600px",
//           overflowY: "scroll",
//           backgroundColor: "#F4F4F4",
//           flex: 1,
//         }}
//       >
//         {data ? (
//           <Box sx={{ textAlign: "center", mt: 4 }}>
//             <Typography
//               variant="h5"
//               sx={{ fontWeight: 600, mb: 2, color: "#2E7D32" }}
//             >
//               Scanned ID:
//             </Typography>
//             <Typography
//               variant="body1"
//               sx={{ color: "#2E7D32", fontWeight: "bold" }}
//             >
//               {data}
//             </Typography>
//             <Button
//               variant="outlined"
//               sx={{
//                 margin: "0 auto",
//                 mt: 5,
//                 display: "block",
//                 color: "#154C79",
//                 borderColor: "#003366",
//                 "&:hover": { borderColor: "#002244" },
//               }}
//               onClick={resetScanning}
//             >
//               Back
//             </Button>
//           </Box>
//         ) : scanning ? renderScanner() : renderActionButtons()}

//         {loading && (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "10vh",
//             }}
//           >
//             <CircularProgress sx={{ color: "#003366" }} />
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default QRScanner;


//---------------------------------------------------------Before Add Job in QR Scan Working Code 2026-02-05-----------------------------------------------------------------------

import React, { useState, useEffect } from "react";
import { Button, Box, Typography, CircularProgress } from "@mui/material";
import { QrReader } from "react-qr-reader";
import HeaderBannerPage from "../components/HeaderBannerPage";
import { useDispatch, useSelector } from "react-redux";
import { QrInOut } from "../actions/QrAction";
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
import { format } from "date-fns";

const QRScanner = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState(""); // Stores scanned QR code result
  const [action, setAction] = useState(""); // State for action selection
  const [scanning, setScanning] = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const [locationError, setLocationError] = useState("");
  const { loading, error, data: apiResponse } = useSelector((state) => state.qr);
  const role = localStorage.getItem("role");

  // Trigger post data when location is updated
  useEffect(() => {
    if (userLocation) sendPostData();
  }, [userLocation]);

  // Request location permission on component load
  useEffect(() => {
    fetchLocation()
      .then(setUserLocation)
      .catch((err) => setLocationError("Failed to fetch location. Please enable location services."));
  }, []);

  // Fetch user's location
  const fetchLocation = async () => {
    try {
      if (!"geolocation" in navigator) {
        throw new Error("Geolocation not supported");
      }

      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position),
          (error) => reject(error),
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      });
    } catch (err) {
      console.error("Error fetching location:", err);
      throw err;
    }
  };


  // Handle action selection (Check In/Check Out)
  const handleAction = (selectedAction) => {
    setAction(selectedAction);
    setData("");
    setScanning(true);
  };

  // Reset scanning state
  const resetScanning = () => {
    setScanning(false);
    setAction("");
    setData("");
  };

  // Format current date and time
  const getFormattedDate = () => format(new Date(), "yyyy-MM-dd HH:mm:ss.SSS");

  // Post scanned data to the server
  const sendPostData = async () => {
    if (!data || !userLocation) return;

    const postData = {
      serviceNo: data,
      InOut: action === "checkIn" ? 1 : 2,
      dateTime: getFormattedDate(),
      geoLocation: JSON.stringify({
        latitude: userLocation.coords.latitude,
        longitude: userLocation.coords.longitude,
        accuracy: userLocation.coords.accuracy,
        altitude: userLocation.coords.altitude,
        heading: userLocation.coords.heading,
        speed: userLocation.coords.speed,
      }),
      location: role,
    };

    try {
      dispatch(QrInOut(postData));
      console.log("Data posted successfully:", postData);
    } catch (err) {
      console.error("Error posting data:", err);
    }
  };

  // Render action buttons (Check In/Check Out)
  const renderActionButtons = () => (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}>
      <Button
        variant="contained"
        sx={{
          borderRadius: "20px",
          padding: "12px 24px",
          backgroundColor: "#142c54",
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#1B5E20" },
        }}
        onClick={() => handleAction("checkIn")}
      >
        <FiArrowDownLeft size={20} color="#FFFFFF" /> Check In
      </Button>
      <Button
        variant="contained"
        sx={{
          borderRadius: "20px",
          padding: "12px 24px",
          backgroundColor: "#B71C1C",
          color: "#FFFFFF",
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#B71C1C" },
        }}
        onClick={() => handleAction("checkOut")}
      >
        <FiArrowUpRight size={20} color="#FFFFFF" /> Check Out
      </Button>
    </Box>
  );
  

  // Render QR scanner
  const renderScanner = () => (
    <Box
      sx={{
        width: "100%",
        maxWidth: "400px",
        mt: 4,
        margin: "0 auto",
        textAlign: "center",
        position: "relative",
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, mb: 2, color: "#154C79" }}
      >
        {action === "checkIn" ? "Check In QR Scan Open Now" : "Check Out QR Scan Open Now"}
      </Typography>
      <Button
        variant="outlined"
        sx={{
          margin: "0 auto",
          mt: 5,
          display: "block",
          color: "#154C79",
          borderColor: "#003366",
          "&:hover": { borderColor: "#002244" },
        }}
        onClick={resetScanning}
      >
        Back
      </Button>
      <Box
        sx={{
          width: "100%",
          maxWidth: "400px",
          height: "400px",
          borderRadius: "8px",
          overflow: "hidden",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          backgroundColor: "#fff",
        }}
      >
        <QrReader
          onResult={(result) => {
            if (result) {
              setData(result?.text);
              setScanning(false);
              fetchLocation().then(setUserLocation).catch(console.error);
            }
          }}
          constraints={{ facingMode: "environment" }}
        />
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <HeaderBannerPage />
      <Box
        sx={{
          padding: "1px",
          fontFamily: "Arial, sans-serif",
          maxHeight: "600px",
          overflowY: "scroll",
          backgroundColor: "#F4F4F4",
          flex: 1,
        }}
      >
        {locationError && (
          <Typography variant="body1" sx={{ color: "red", textAlign: "center", mt: 2 }}>
            {locationError}
          </Typography>
        )}
        {data ? (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 600, mb: 2, color: "#2E7D32" }}
            >
              Scanned ID:
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "#2E7D32", fontWeight: "bold" }}
            >
              {data}
            </Typography>
            <Button
              variant="outlined"
              sx={{
                margin: "0 auto",
                mt: 5,
                display: "block",
                color: "#154C79",
                borderColor: "#003366",
                "&:hover": { borderColor: "#002244" },
              }}
              onClick={resetScanning}
            >
              Back
            </Button>
          </Box>
        ) : scanning ? renderScanner() : renderActionButtons()}

        {loading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "10vh",
            }}
          >
            <CircularProgress sx={{ color: "#003366" }} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default QRScanner;

// import React, { useState, useEffect } from "react";
// import { Button, Box, Typography, CircularProgress } from "@mui/material";
// import { QrReader } from "react-qr-reader";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { useDispatch, useSelector } from "react-redux";
// import { QrInOut } from "../actions/QrAction";
// import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
// import { format } from "date-fns";

// const QRScanner = () => {
//   const dispatch = useDispatch();
//   const [data, setData] = useState(""); // Stores scanned QR code result
//   const [action, setAction] = useState(""); // State for action selection
//   const [scanning, setScanning] = useState(false);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationError, setLocationError] = useState("");
//   const { loading, error, data: apiResponse } = useSelector((state) => state.qr);
//   const role = localStorage.getItem("role");

//   //-------Dulitha------
//   const [jobAction, setJobAction] = useState(""); // State for Job In/Job Out
//   const [jobData, setJobData] = useState(""); // Stores scanned QR for job
//   const [jobScanning, setJobScanning] = useState(false);
//   const [jobScanTime, setJobScanTime] = useState(""); // Stores scan time for job


//   // Trigger post data when location is updated
//   useEffect(() => {
//     if (userLocation) sendPostData();
//   }, [userLocation]);

//   // Request location permission on component load
//   useEffect(() => {
//     fetchLocation()
//       .then(setUserLocation)
//       .catch((err) => setLocationError("Failed to fetch location. Please enable location services."));
//   }, []);

//   // Fetch user's location
//   const fetchLocation = async () => {
//     try {
//       if (!"geolocation" in navigator) {
//         throw new Error("Geolocation not supported");
//       }

//       return new Promise((resolve, reject) => {
//         navigator.geolocation.getCurrentPosition(
//           (position) => resolve(position),
//           (error) => reject(error),
//           { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
//         );
//       });
//     } catch (err) {
//       console.error("Error fetching location:", err);
//       throw err;
//     }
//   };

//   // Handle action selection (Check In/Check Out)
//   const handleAction = (selectedAction) => {
//     setAction(selectedAction);
//     setData("");
//     setScanning(true);
//   };

//   //-------Dulitha------
//   // Handle job action selection (Job In/Job Out)
//   const handleJobAction = (selectedAction) => {
//     setJobAction(selectedAction);
//     setJobData("");
//     setJobScanTime("");
//     setJobScanning(true);
//   };

//   // Reset scanning state
//   const resetScanning = () => {
//     setScanning(false);
//     setAction("");
//     setData("");
//   };

//   // Reset job scanning state
//   const resetJobScanning = () => {
//     setJobScanning(false);
//     setJobAction("");
//     setJobData("");
//     setJobScanTime("");
//   };

//   // Format current date and time
//   const getFormattedDate = () => format(new Date(), "yyyy-MM-dd HH:mm:ss.SSS");

//   // Post scanned data to the server
//   const sendPostData = async () => {
//     if (!data || !userLocation) return;

//     const postData = {
//       serviceNo: data,
//       InOut: action === "checkIn" ? 1 : 2,
//       dateTime: getFormattedDate(),
//       geoLocation: JSON.stringify({
//         latitude: userLocation.coords.latitude,
//         longitude: userLocation.coords.longitude,
//         accuracy: userLocation.coords.accuracy,
//         altitude: userLocation.coords.altitude,
//         heading: userLocation.coords.heading,
//         speed: userLocation.coords.speed,
//       }),
//       location: role,
//     };

//     try {
//       dispatch(QrInOut(postData));
//       console.log("Data posted successfully:", postData);
//     } catch (err) {
//       console.error("Error posting data:", err);
//     }
//   };

//   // Render action buttons (Check In/Check Out)
//   const renderActionButtons = () => (
//     <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}>
//       <Button
//         variant="contained"
//         sx={{
//           borderRadius: "20px",
//           padding: "12px 24px",
//           backgroundColor: "#142c54",
//           fontWeight: "bold",
//           "&:hover": { backgroundColor: "#1B5E20" },
//         }}
//         onClick={() => handleAction("checkIn")}
//       >
//         <FiArrowDownLeft size={20} color="#FFFFFF" /> Check In
//       </Button>
//       <Button
//         variant="contained"
//         sx={{
//           borderRadius: "20px",
//           padding: "12px 24px",
//           backgroundColor: "#B71C1C",
//           color: "#FFFFFF",
//           fontWeight: "bold",
//           "&:hover": { backgroundColor: "#B71C1C" },
//         }}
//         onClick={() => handleAction("checkOut")}
//       >
//         <FiArrowUpRight size={20} color="#FFFFFF" /> Check Out
//       </Button>
//     </Box>
//   );

//   //-------Dulitha------
//   // Render job action buttons
//   const renderJobActionButtons = () => (
//     <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
//       <Button
//         variant="contained"
//         sx={{
//           borderRadius: "20px",
//           padding: "12px 24px",
//           backgroundColor: "#FF6F00",
//           fontWeight: "bold",
//           "&:hover": { backgroundColor: "#E65100" },
//         }}
//         onClick={() => handleJobAction("jobIn")}
//       >
//         <FiArrowDownLeft size={20} color="#FFFFFF" /> Job In
//       </Button>
//       <Button
//         variant="contained"
//         sx={{
//           borderRadius: "20px",
//           padding: "12px 24px",
//           backgroundColor: "#6A1B9A",
//           color: "#FFFFFF",
//           fontWeight: "bold",
//           "&:hover": { backgroundColor: "#4A148C" },
//         }}
//         onClick={() => handleJobAction("jobOut")}
//       >
//         <FiArrowUpRight size={20} color="#FFFFFF" /> Job Out
//       </Button>
//     </Box>
//   );
//   //-------Dulitha------

//   // Render QR scanner
//   const renderScanner = () => (
//     <Box
//       sx={{
//         width: "100%",
//         maxWidth: "400px",
//         mt: 4,
//         margin: "0 auto",
//         textAlign: "center",
//         position: "relative",
//       }}
//     >
//       <Typography
//         variant="h6"
//         sx={{ fontWeight: 600, mb: 2, color: "#154C79" }}
//       >
//         {action === "checkIn" ? "Check In QR Scan Open Now" : "Check Out QR Scan Open Now"}
//       </Typography>
//       <Button
//         variant="outlined"
//         sx={{
//           margin: "0 auto",
//           mt: 5,
//           display: "block",
//           color: "#154C79",
//           borderColor: "#003366",
//           "&:hover": { borderColor: "#002244" },
//         }}
//         onClick={resetScanning}
//       >
//         Back
//       </Button>
//       <Box
//         sx={{
//           width: "100%",
//           maxWidth: "400px",
//           height: "400px",
//           borderRadius: "8px",
//           overflow: "hidden",
//           boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//           backgroundColor: "#fff",
//         }}
//       >
//         <QrReader
//           onResult={(result) => {
//             if (result) {
//               setData(result?.text);
//               setScanning(false);
//               fetchLocation().then(setUserLocation).catch(console.error);
//             }
//           }}
//           constraints={{ facingMode: "environment" }}
//         />
//       </Box>
//     </Box>
//   );

//   //-------Dulitha------
//   // Render Job QR scanner
//   const renderJobScanner = () => (
//     <Box
//       sx={{
//         width: "100%",
//         maxWidth: "400px",
//         mt: 4,
//         margin: "0 auto",
//         textAlign: "center",
//         position: "relative",
//       }}
//     >
//       <Typography
//         variant="h6"
//         sx={{ fontWeight: 600, mb: 2, color: "#154C79" }}
//       >
//         {jobAction === "jobIn" ? "Job In QR Scan Open Now" : "Job Out QR Scan Open Now"}
//       </Typography>
//       <Button
//         variant="outlined"
//         sx={{
//           margin: "0 auto",
//           mt: 5,
//           display: "block",
//           color: "#154C79",
//           borderColor: "#003366",
//           "&:hover": { borderColor: "#002244" },
//         }}
//         onClick={resetJobScanning}
//       >
//         Back
//       </Button>
//       <Box
//         sx={{
//           width: "100%",
//           maxWidth: "400px",
//           height: "400px",
//           borderRadius: "8px",
//           overflow: "hidden",
//           boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//           backgroundColor: "#fff",
//         }}
//       >
//         <QrReader
//           onResult={(result) => {
//             if (result) {
//               const scannedTime = getFormattedDate();
//               const employeeId = localStorage.getItem("employeeId");
//               setJobData(result?.text);
//               setJobScanTime(scannedTime);
//               setJobScanning(false);
//               console.log("Job Scan Data:", {
//                 qrValue: result?.text,
//                 serviceNo: employeeId,
//                 scannedTime: scannedTime,
//                 action: jobAction
//               });
//             }
//           }}
//           constraints={{ facingMode: "environment" }}
//         />
//       </Box>
//     </Box>
//   );

//   //-------Dulitha------
//   // Render job scan result
//   const renderJobResult = () => {
//     const employeeId = localStorage.getItem("employeeId");
    
//     return (
//       <Box sx={{ textAlign: "center", mt: 4 }}>
//         <Typography
//           variant="h5"
//           sx={{ fontWeight: 600, mb: 2, color: "#FF6F00" }}
//         >
//           {jobAction === "jobIn" ? "Job In Scanned" : "Job Out Scanned"}
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{ color: "#154C79", fontWeight: "bold", mb: 1 }}
//         >
//           Service No: {employeeId}
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{ color: "#154C79", fontWeight: "bold", mb: 1 }}
//         >
//           QR Value: {jobData}
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{ color: "#154C79", fontWeight: "bold" }}
//         >
//           Scanned Time: {jobScanTime}
//         </Typography>
//         <Button
//           variant="outlined"
//           sx={{
//             margin: "0 auto",
//             mt: 5,
//             display: "block",
//             color: "#154C79",
//             borderColor: "#003366",
//             "&:hover": { borderColor: "#002244" },
//           }}
//           onClick={resetJobScanning}
//         >
//           Back
//         </Button>
//       </Box>
//     );
//   };
//   //-------Dulitha------

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         height: "100vh",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <HeaderBannerPage />
//       <Box
//         sx={{
//           padding: "1px",
//           fontFamily: "Arial, sans-serif",
//           maxHeight: "600px",
//           overflowY: "scroll",
//           backgroundColor: "#F4F4F4",
//           flex: 1,
//         }}
//       >
//         {locationError && (
//           <Typography variant="body1" sx={{ color: "red", textAlign: "center", mt: 2 }}>
//             {locationError}
//           </Typography>
//         )}
//         {data ? (
//           <Box sx={{ textAlign: "center", mt: 4 }}>
//             <Typography
//               variant="h5"
//               sx={{ fontWeight: 600, mb: 2, color: "#2E7D32" }}
//             >
//               Scanned ID:
//             </Typography>
//             <Typography
//               variant="body1"
//               sx={{ color: "#2E7D32", fontWeight: "bold" }}
//             >
//               {data}
//             </Typography>
//             <Button
//               variant="outlined"
//               sx={{
//                 margin: "0 auto",
//                 mt: 5,
//                 display: "block",
//                 color: "#154C79",
//                 borderColor: "#003366",
//                 "&:hover": { borderColor: "#002244" },
//               }}
//               onClick={resetScanning}
//             >
//               Back
//             </Button>
//           </Box>
//         ) : scanning ? (
//           renderScanner()
//         ) : jobData ? (
//           renderJobResult()
//         ) : jobScanning ? (
//           renderJobScanner()
//         ) : (
//           <>
//             {renderActionButtons()}
//             {renderJobActionButtons()}
//           </>
//         )}

//         {loading && (
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "10vh",
//             }}
//           >
//             <CircularProgress sx={{ color: "#003366" }} />
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default QRScanner;